import React from 'react';
import { AlertCircle } from 'lucide-react';
import C from '../../constants/colors';

export default function ConfirmModal({ title, message, onConfirm, onClose }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{
        background: C.surfaceElevated, border: `1px solid ${C.border}`,
        borderRadius: '14px', padding: '28px', width: '420px', maxWidth: '90vw',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
          <AlertCircle size={20} color={C.red} />
          <h3 style={{ fontSize: '16px', fontWeight: 700, color: C.textPrimary }}>{title}</h3>
        </div>
        <p style={{ fontSize: '14px', color: C.textSecondary, marginBottom: '24px', lineHeight: 1.5 }}>
          {message}
        </p>
        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{
            padding: '8px 20px', borderRadius: '8px', border: `1px solid ${C.border}`,
            background: 'transparent', color: C.textSecondary, fontSize: '13px',
            cursor: 'pointer', fontFamily: 'inherit',
          }}>Cancel</button>
          <button onClick={() => { onConfirm(); onClose(); }} style={{
            padding: '8px 20px', borderRadius: '8px', border: 'none',
            background: C.red, color: '#fff', fontSize: '13px', fontWeight: 600,
            cursor: 'pointer', fontFamily: 'inherit',
          }}>Confirm</button>
        </div>
      </div>
    </div>
  );
}
